
export const getNewGuid = (): string =>  {
    let d = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16);
    });
    return uuid;
}

export const getGuidFromString = (str: string): string => {
    const temp = str.replace(/[^0-9a-zA-Z]+/g, "");
    if (temp.length === 32)
        return temp.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
    return "";
}

export const isGuidNullOrEmpty = (guid: string): boolean =>{
    return !guid || guid === "00000000-0000-0000-0000-000000000000";
}